import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import "./../../Products/Faq/Faq.css";
import AskFaq from "../../../Images/askFaq.png";
import { useNavigate } from "react-router-dom";
function ProductEquityFAQ() {
    let navigate = useNavigate();
    const TermsCondition = () => {
        let path = `../TermsCondition`;
        navigate(path, { state: { plan: "main" } });
    };
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                  Q1. Why should an investor consider investing in Equities?
                  </Accordion.Header>
                  <Accordion.Body className="textjustify">
                    <p>
                    Investors buy stock of a corporation with a belief that it will appreciate in value and might pay out dividends. Equities may improve a portfolio's asset allocation by diversifying it. Such investments are seen as alternatives to traditional investments like gold, Fixed deposit, real estate etc.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Q2. How can I invest in stocks with Moneysukh?
                  </Accordion.Header>
                   <Accordion.Body className="textjustify">
                    <ul>
                      <li> Visit trade.moneysukh.com and login through your Moneysukh User ID & password</li>
                      <li>Search for the stock you want to buy. You need to ensure to have a sufficient amount for buying the shares.</li>
                      <li>Select the price at which you want to buy the stock.</li>
                      <li>Conclude the transaction and the stock s will be credit to your demat account.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Q3. What are the charges associated with stock investing and trading?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                    You can check the charges for trading in equity segment from <a href="/Pricing">here</a>.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q4. Will Moneysukh provide interest on my Stock investment’s also?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                                          No, Interest will not be provided on Stock investments. For future reference please refer <a className="linkhere" onClick={() => TermsCondition()}>here</a>.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Q5. What Are Advances and Declines in stock market?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      The Advance/Decline, or A/D ratio, is a popular metric for
                      determining market sentiment. It counts the number of
                      shares that rose and divides it by the number of shares
                      that fell. It indicates whether market movement is widely
                      dispersed or concentrated in a few stocks.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ProductEquityFAQ;
